import { CapoPlugin } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];